import { API_REQUEST } from "../..";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  addProjectListEndPointURL,
  fetchHireTalentDeliveableProjectDetailsEndPointURL,
  fetchHireTalentRecommendedEndPointURL,
  markAsCompleteAPI,
  projectDetailsAPI,
  projectsAPI,
  recommendedFreelancerAPI,
  sendInvitationToFreelancerAPI,
  uploadDeliveableProjectHireTalentEndPointURL,
} from "../../../../routes/apiurls";

// fetch-my-projects
export const fetchMyProjects = createAsyncThunk(
  "fetch-my-projects",
  async () => {
    try {
      const response = await API_REQUEST({
        url: projectsAPI,
        method: "GET",
        currentPanel: "hire-talent",
      });
      return response;
    } catch (error) { }
  }
);

// fetch-project-details
export const fetchProjectDetails = createAsyncThunk(
  "fetch-project-details",
  async (props) => {
    try {
      const { payload } = props || {};
      const response = await API_REQUEST({
        url: projectDetailsAPI + payload,
        method: "GET",
        currentPanel: "hire-talent",
      });
      return response;
    } catch (error) { }
  }
);

export const fetchProjectDeliveableHireDetails = createAsyncThunk(
  "fetch-project-delieable-details",
  async (props) => {
    try {
      const { payload } = props || {};
      const response = await API_REQUEST({
        url: fetchHireTalentDeliveableProjectDetailsEndPointURL + payload,
        method: "GET",
        currentPanel: "hire-talent",
      });
      return response;
    } catch (error) { }
  }
);

// fetch-recommended-freelancer
export const fetchRecommendedFreelancer = createAsyncThunk(
  "fetch-recommended-freelancer",
  async () => {
    try {
      const response = await API_REQUEST({
        url: recommendedFreelancerAPI,
        method: "GET",
        currentPanel: "hire-talent",
      });
      return response;
    } catch (error) { }
  }
);

// hire-talent/projects-matching-talents/
export const fetchRecommendedHireTalentMactching = createAsyncThunk(
  "fetch-recommended-hire-talent-matching",
  async (props) => {
    const { payload } = props;
    try {
      const response = await API_REQUEST({
        url: fetchHireTalentRecommendedEndPointURL + payload,
        method: "GET",
        currentPanel: "hire-talent",
      });
      return response;
    } catch (error) { }
  }
);

export const addProjectDetails = createAsyncThunk(
  "add-project-details",
  async (props) => {
    const { payload, callback } = props;
    try {
      const response = await API_REQUEST({
        url: addProjectListEndPointURL,
        method: "POST",
        currentPanel: "hire-talent",
        data: payload
      });
      callback(response)
      return response;
    } catch (error) {
      callback(null, error);
    };
  }
);

// send-invitation-to-freelancer
export const sendInvitationToFreelancer = createAsyncThunk(
  "send-invitation-to-freelancer",
  async (props) => {
    try {
      const { payload, callback } = props || {};
      const response = await API_REQUEST({
        url: sendInvitationToFreelancerAPI,
        method: "POST",
        data: payload,
        currentPanel: "hire-talent",
      });
      callback(response);
      return response;
    } catch (error) { }
  }
);

// mark-as-completed
export const markAsComplete = createAsyncThunk(
  "mark-as-completed",
  async (props) => {
    const { payload, callback } = props || {};
    try {
      const response = await API_REQUEST({
        url: markAsCompleteAPI,
        method: "POST",
        data: payload,
        currentPanel: "hire-talent",
      });
      callback(response);
      return response;
    } catch (error) {
      // callback(error, null)
    }
  }
);


export const uploadDeliveableProject = createAsyncThunk(
  "uplaod-deliveable-project",
  async (props) => {
    const { payload, callback } = props || {};
    try {
      const response = await API_REQUEST({
        url: uploadDeliveableProjectHireTalentEndPointURL,
        method: "POST",
        data: payload,
        currentPanel: "hire-talent",
      });
      callback(response);
      return response;
    } catch (error) {
      callback(error, null)
    }
  }
);
